import Base from './Base'
import Catalog from './Catalog'
import Category from './Category'
import Pizza from './Pizza'
import Simple from './Simple'
import Step from './Step'
import Edge from './Edge'
import Extraingredient from './Extraingredient'
import Question from './Question'
import Flavor from './Flavor'
import Option from './Option'
import Reference from './Reference'

const classes = {
    Base,
    Catalog,
    Category,
    Pizza,
    Simple,
    Step,
    Edge,
    Extraingredient,
    Question,
    Flavor,
    Option
};

String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1) 
}
  
export default class Builder {
 
    static factory(className, ...args) {
        return new classes[className];
    }
    
    static generateRandomId (prefix = '') {
        var timestamp = (new Date().getTime() / 1000 | 0).toString(16)
        return prefix + timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function() {
            return (Math.random() * 16 | 0).toString(16)
        }).toLowerCase()
    }

    static mountSchema(item) {
        let $class = item.type.capitalize();
        let obj = Builder.factory($class);
        
        if(item.ref_id) { 
          Reference.addToReference(item.ref_id, obj);
        }
  
        ['extra_ingredients', 'edges', 'items'].map((prop) => {
            if(Array.isArray(item[prop]) && item[prop].length > 0) { 
                obj.addItems(item[prop].map(Builder.mountSchema)); 
                obj[prop].sort((a, b) => a.position - b.position)
            }
            delete item[prop];
        });
        
        for(var param in item) { 
            obj[param] = item[param]; 
        }
        return obj;
    }
  
    static mountSchemaByList(item, list) {
        let $class = item.type.capitalize();
        let obj = eval(`new ${$class}`);
  
        let to_process = { ...item };
        
        delete to_process.items;
        delete to_process.edges;
        delete to_process.extra_ingredients;
  
        for(var k in to_process) {
            obj[k] = to_process[k];
        }
  
        let tmp_list = list.filter((child) => child.parent == item._id)
        if(tmp_list.length > 0) {
            obj.addItems(tmp_list.map((i) => Builder.mountSchemaByList(i, list)));
        }
  
        return obj;
    }
  
    static executeOnSchema(schema, callback, ...extra_params) {
        for(var field of ['items', 'extra_ingredients', 'edges']) {
            for(var item of schema[field]) {
                callback(item, ...extra_params);
                Builder.executeOnSchema(item, callback, ...extra_params);
            }
        }
    }
}
  